<template>
  <div>
    <br />

    <div v-if='hasRoles("HRL", "SS", "ACC")'>
      <ApplicationsTable />
    </div>
    <div v-else>
      <div v-if='hasRoles("K12-STUDENT", "STUDENT", "RESIDENT-ASSISTANT")'>
        <StudentLanding />
      </div>
      <div v-else>
        <h5>
          You do not have proper credentials to access the Housing Portal. <br />
          Please contact Housing Staff or R&D to gain access.
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import useAuth from '@/hooks/auth';
import StudentLanding from './Landing/StudentLanding.vue';
import ApplicationsTable from './Application/ApplicationsTable.vue';

export default {
  components: {
    StudentLanding,
    ApplicationsTable,
  },
  async setup() {
    const { hasRoles } = useAuth();

    return {
      hasRoles,
    };
  },
};
</script>
